// Progressive enhancement for sm-collection-grid: checkbox filters navigate to the
// server-computed add/remove URL (no client-side product fetching), and the mobile
// filter button toggles the sidebar. Works without JS: checkboxes still show state,
// and the collection re-renders fully server side on any link/form submit.
function initCollectionGrid(section) {
  const toggle = section.querySelector('[data-sm-cg-filter-toggle]');
  const sidebar = section.querySelector('.sm-cg__sidebar');
  if (toggle && sidebar) {
    toggle.addEventListener('click', () => {
      const open = sidebar.classList.toggle('sm-cg__sidebar--open');
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('sm-scroll-locked', open);
    });
  }

  section.querySelectorAll('[data-sm-cg-filter-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const url = input.checked ? input.dataset.add : input.dataset.remove;
      if (url) window.location.href = url;
    });
  });
}

document.querySelectorAll('[data-section="sm-collection-grid"]').forEach(initCollectionGrid);
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('[data-section="sm-collection-grid"]');
  if (section) initCollectionGrid(section);
});
